import { gql } from '@apollo/client';

export const GET_ACCOUNTS = gql`
    query GetAccounts {
        accounts {
            id,
            firstName,
            lastName,
            email,
            # enterprises {
            #     id,
            #     legalName
            # }
        }
    }
`;

export const GET_ACCOUNT = gql`
    query GetAccount($id: String!) {
        account(id: $id) {
            id,
            firstName,
            lastName,
            email,
            # enterprises {
            #     id,
            #     legalName
            # }
        }
    }
`;
